export default "__VITE_ASSET__n6KoqQqY__"